import styles from "./checkout.module.css";

export default function Loader({ size = 20, color = "#fff" }) {
  return (
    <div
      className={styles.spinner}
      style={{
        width: size,
        height: size,
        borderColor: `${color}30`,
        borderTopColor: color,
      }}
    />
  );
}
